"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceCopyRequestDto = void 0;
const tslib_1 = require("tslib");
const swagger_v4_1 = require("@nestjs/swagger-v4");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const common_1 = require("@goparrot/common");
class PriceCopyRequestDto {
}
tslib_1.__decorate([
    (0, class_transformer_1.Expose)({ groups: [common_1.DefaultExposeGroupEnum.PATCH] }),
    (0, class_validator_1.IsString)({ always: true }),
    (0, class_validator_1.IsNotEmpty)({ always: true }),
    (0, swagger_v4_1.ApiProperty)({
        type: () => String,
        description: 'Source store id',
        uniqueItems: true,
    }),
    tslib_1.__metadata("design:type", String)
], PriceCopyRequestDto.prototype, "sourceStoreId", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Expose)({ groups: [common_1.DefaultExposeGroupEnum.PATCH] }),
    (0, class_validator_1.IsString)({ always: true }),
    (0, class_validator_1.IsNotEmpty)({ always: true }),
    (0, swagger_v4_1.ApiProperty)({
        type: () => String,
        description: 'Destination store id',
        uniqueItems: true,
    }),
    tslib_1.__metadata("design:type", String)
], PriceCopyRequestDto.prototype, "destinationStoreId", void 0);
exports.PriceCopyRequestDto = PriceCopyRequestDto;
//# sourceMappingURL=PriceCopyRequestDto.js.map